export default __webpack_public_path__ + "static/media/fw-emma-er-Yellow Gold.3d494ded.mp4";